<template>
  <div>
    <app-header></app-header>

    <!-- Left side column. contains the sidebar -->
    <app-sidebar></app-sidebar>

    <!-- Content Wrapper. Contains page content -->
    <router-view :key="$route.fullPath"></router-view>
    <!-- /.content-wrapper -->

    <app-footer></app-footer>

    <!-- <control-sidebar></control-sidebar> -->
  </div>
</template>

<script>
  import Sidebar from './partials/Sidebar';
  import Header from './partials/Header';
  import Footer from './partials/Footer';
  import ControlSidebar from './partials/ControlSidebar';

  export default {
    name: 'Dashboard',
    components: {
      'app-sidebar': Sidebar,
      'app-header': Header,
      'app-footer': Footer,
      'control-sidebar': ControlSidebar,
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue